export default "__VITE_ASSET__23jX1Vu9__"